export enum CoverageTypeEnum {
  Comp = 'Comp',
  CompPlus = 'CompPlus',
  TPFT = 'TPFT',
  Drivexpert = 'DriveXpert',
  Essentials = 'Essentials',
  EssentialsPcw = 'EssentialsPcw',
  CompPcw = 'CompPcw',
  CompPlusPcw = 'CompPlusPcw',
}

export enum CoverageTypeEnumSimple {
  Comp = 'comp',
  CompPlus = 'compplus',
  TPFT = 'tpft',
  Drivexpert = 'drivexpert',
  Essentials = 'compessential',
  EssentialsPcw = 'essentialspcw',
  CompPcw = 'comppcw',
  CompPlusPcw = 'comppluspcw',
}

export enum CoverageTypeNames {
  Essentials = 'Essentials',
  Comp = 'Comprehensive',
  CompPlus = 'Comprehensive Plus',
  TPFT = 'Third Party, Fire and Theft',
  Drivexpert = 'DriveXpert',
  EssentialsPcw = 'Essentials Online',
  CompPcw = 'Standard Online',
  CompPlusPcw = 'Premium Online',

}

export enum CoverageTypeNamesSimple {
  comp = 'Comprehensive',
  compplus = 'Comprehensive Plus',
  tpft = 'Third Party, Fire and Theft',
  drivexpert = 'DriveXpert',
  compessential = 'Essentials',
  essentialspcw = 'Essentials Online',
  comppcw = 'Standard Online',
  comppluspcw = 'Premium Online',
  DriveSure = 'DriveSure',
  DrivePlus = 'DrivePlus'
}

export enum CoveragePIDLinks {
  Comp = 'Comp-1122.pdf',
  CompPlus = 'Compplus-1122.pdf',
  TPFT = 'TPFT-1122.pdf',
  Essentials = 'Compessentials-1122.pdf',
}

export enum CoveragePIDPCWLinks {
  Comp = 'Comp-1124.pdf',
  CompPlus = 'Compplus-1124.pdf',
  TPFT = 'TPFT-1124.pdf',
  Essentials = 'Compessentials-1124.pdf',
  CompPcw = 'Comppcw-1124.pdf',
  CompPlusPcw = 'Comppluspcw-1124.pdf',
  EssentialsPcw = 'Compessentialspcw-1124.pdf',
}

export enum CoverageBookletTypes {
  Comp = 'Comp',
  CompPlus = 'Compplus',
  TPFT = 'TPFT',
  Drivexpert = 'Telematics',
  CompPcw = 'CompPcw',
  CompPlusPcw = 'CompplusPcw',
}

export enum CoverageRescueTypes {
  ukDirectline = 'rescueukeuro-0824.pdf',
  euroDirectline = 'rescueeuro-0824.pdf',
  migratedDirectline = 'rescueukeuro-mig-0824.pdf',
  ukOther = 'rescueukeuro-ipid-1122.pdf',
  euroOther = 'rescueeuro-ipid-1122.pdf',
}

export type SelectedCover = Record<CoverageTypeEnumSimple, string>;
export type CoverType = `${CoverageTypeEnumSimple}`;
